/**
 *  Alaska: Editor
 *  Public: Card Slider
 *
 *  @version 1.0
 */

import Splide from '@splidejs/splide';

document.addEventListener('alpine:init', () => {
    Alpine.data('cardSlider', () => ({
        isSlider: false,
        splide: null,

        init() {
            const cards = this.$el.querySelectorAll('.item');

            if (cards.length > 3) {
                this.isSlider = true;

                this.$nextTick(() => {
                    this.splide = new Splide(this.$refs.splide, {
                        type: 'slide',
                        perPage: 3,
                        perMove: 1,
                        gap: '2rem',
                        arrows: true,
                        pagination: false,
                        speed: 600,
                        breakpoints: {
                            1024: {
                                perPage: 2,
                                perMove: 1,
                            },
                            640: {
                                perPage: 1,
                                perMove: 1,
                            }
                        },
                    }).mount();
                });
            }
        },
    }));
});